export const mainBoxContainerStyles = {
    width: "100%",
    paddingRight: 1,
    border: "none",
    boxShadow: "none",
  };
  
 export const tablePaperContainerStyles = {
    maxWidth: "100%",
    mb: 1,
    border: "none",
    boxShadow: "none",
    mt: 1,
    height: "67vh",
  };